import { CustomContentDto } from '@app/promotionHub/shared/types/CustomContent';
import { PromotionBonusType } from '@app/promotionHub/promotions/types/Promotion';

export type ComtradePromotionDto = {
    BonusName: string;
    BonusCategory: number | null;
    BonusType: PromotionBonusType | null;
    BonusExpirationDate: string | null;
    CouponEventId: number | null;
    Description: string;
    ICoreAggregatedBonusStatus: PromotionBonusStatusDto;
    OptInCode: string | null;
    Priority: number | null;
    ProductTypeId: number | null;
    PromotionActivationDate: string | null;
    PromotionEndDate: string;
    PromotionFriendlyName: string | null;
    PromotionId: number;
    PromotionName: string;
    PromotionStatus: PromotionStatusDto | null;
    PromotionType: number;
    Recommended: boolean | null;
    RecommendedPriority: number | null;
    CustomContentList?: CustomContentDto[];
};

export const PromotionStatusDto = {
    OptedIn: 1,
    OptedOut: 2,
    NoOptInRequired: 3,
};
export type PromotionStatusDto = typeof PromotionStatusDto[keyof typeof PromotionStatusDto];

export const PromotionBonusStatusDto = {
    Available: 1,
    Active: 2,
    Success: 3,
    Failed: 4,
    Other: 5,
};
export type PromotionBonusStatusDto = typeof PromotionBonusStatusDto[keyof typeof PromotionBonusStatusDto];
